import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "@/pages/home/index";
import NotFound from "@/pages/not-found/Index";
import { LangProvider } from "@/i18n/LangContext";

export const ROUTE_PATHS = {
  HOME: "/",
};

export default function App() {
  return (
    <LangProvider>
      <Router>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </LangProvider>
  );
}
